<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M12 13v10"/>
  <circle cx="12" cy="7" r="6" fill="#000" stroke="#000"/>
</svg>
